export const countryToCode = {
  "United States": "USA",
  Brazil: "BRA",
  Vietnam: "VNM",
  Colombia: "COL",
  Indonesia: "IDN",
  Ethiopia: "ETH",
  Honduras: "HND",
  India: "IND",
  Bangladesh: "BGD",
  Uganda: "UGA",
  Mexico: "MEX",
  Guatemala: "GTM",
  Peru: "PER",
  Nicaragua: "NIC",
  China: "CHN",
  "Ivory Coast": "CIV",
  "Costa Rica": "CRI",
  Kenya: "KEN",
  "Papua New Guinea": "PNG",
  Tanzania: "TZA",
  "El Salvador": "SLV",
  Ecuador: "ECU",
  Cameroon: "CMR",
  Laos: "LAO",
  Venezuela: "VEN",
  "Dominican Republic": "DOM",
  Haiti: "HTI",
  "Democratic Republic of the Congo": "COD",
  Rwanda: "RWA",
  Burundi: "BDI",
  Philippines: "PHL",
  Afghanistan: "AFG",
  Albania: "ALB",
  Algeria: "DZA",
  Andorra: "AND",
  Angola: "AGO",
  "Antigua and Barbuda": "ATG",
  Argentina: "ARG",
  Armenia: "ARM",
  Australia: "AUS",
  Austria: "AUT",
  Azerbaijan: "AZE",
  Bahamas: "BHS",
  Bahrain: "BHR",
  Barbados: "BRB",
  Belarus: "BLR",
  Belgium: "BEL",
  Belize: "BLZ",
  Benin: "BEN",
  Bhutan: "BTN",
  Bolivia: "BOL",
  "Bosnia and Herzegovina": "BIH",
  Botswana: "BWA",
  Brunei: "BRN",
  Bulgaria: "BGR",
  "Burkina Faso": "BFA",
  "Cabo Verde": "CPV",
  Cambodia: "KHM",
  Canada: "CAN",
  "Central African Republic": "CAF",
  Chad: "TCD",
  Chile: "CHL",
  Comoros: "COM",
  Congo: "COG",
  "Cook Islands": "COK",
  Croatia: "HRV",
  Cuba: "CUB",
  Cyprus: "CYP",
  "Czech Republic": "CZE",
  Denmark: "DNK",
  Djibouti: "DJI",
  Dominica: "DMA",
  "East Timor": "TLS",
  Egypt: "EGY",
  "Equatorial Guinea": "GNQ",
  Eritrea: "ERI",
  Estonia: "EST",
  Eswatini: "SWZ",
  Fiji: "FJI",
  Finland: "FIN",
  France: "FRA",
  Gabon: "GAB",
  Gambia: "GMB",
  Georgia: "GEO",
  Germany: "DEU",
  Ghana: "GHA",
  Greece: "GRC",
  Grenada: "GRD",
  Guinea: "GIN",
  "Guinea-Bissau": "GNB",
  Guyana: "GUY",
  Hungary: "HUN",
  Iceland: "ISL",
  Iran: "IRN",
  Iraq: "IRQ",
  Ireland: "IRL",
  Israel: "ISR",
  Italy: "ITA",
  Jamaica: "JAM",
  Japan: "JPN",
  Jordan: "JOR",
  Kazakhstan: "KAZ",
  Kiribati: "KIR",
  Kuwait: "KWT",
  Kyrgyzstan: "KGZ",
  Latvia: "LVA",
  Lebanon: "LBN",
  Lesotho: "LSO",
  Liberia: "LBR",
  Libya: "LBY",
  Liechtenstein: "LIE",
  Lithuania: "LTU",
  Luxembourg: "LUX",
  Madagascar: "MDG",
  Malawi: "MWI",
  Malaysia: "MYS",
  Maldives: "MDV",
  Mali: "MLI",
  Malta: "MLT",
  "Marshall Islands": "MHL",
  Mauritania: "MRT",
  Mauritius: "MUS",
  Micronesia: "FSM",
  Moldova: "MDA",
  Monaco: "MCO",
  Mongolia: "MNG",
  Montenegro: "MNE",
  Morocco: "MAR",
  Mozambique: "MOZ",
  Myanmar: "MMR",
  Namibia: "NAM",
  Nauru: "NRU",
  Nepal: "NPL",
  Netherlands: "NLD",
  "New Zealand": "NZL",
  Niger: "NER",
  Nigeria: "NGA",
  "North Korea": "PRK",
  "North Macedonia": "MKD",
  Norway: "NOR",
  Oman: "OMN",
  Pakistan: "PAK",
  Palau: "PLW",
  Palestine: "PSE",
  Panama: "PAN",
  Paraguay: "PRY",
  Poland: "POL",
  Portugal: "PRT",
  Qatar: "QAT",
  Romania: "ROU",
  Russia: "RUS",
  "Saint Kitts and Nevis": "KNA",
  "Saint Lucia": "LCA",
  "Saint Vincent and the Grenadines": "VCT",
  Samoa: "WSM",
  "San Marino": "SMR",
  "Sao Tome and Principe": "STP",
  "Saudi Arabia": "SAU",
  Senegal: "SEN",
  Serbia: "SRB",
  Seychelles: "SYC",
  "Sierra Leone": "SLE",
  Singapore: "SGP",
  Slovakia: "SVK",
  Slovenia: "SVN",
  "Solomon Islands": "SLB",
  Somalia: "SOM",
  "South Africa": "ZAF",
  "South Korea": "KOR",
  "South Sudan": "SSD",
  Spain: "ESP",
  "Sri Lanka": "LKA",
  Sudan: "SDN",
  Suriname: "SUR",
  Sweden: "SWE",
  Switzerland: "CHE",
  Syria: "SYR",
  Tajikistan: "TJK",
  Thailand: "THA",
  Togo: "TGO",
  Tonga: "TON",
  "Trinidad and Tobago": "TTO",
  Tunisia: "TUN",
  Turkey: "TUR",
  Turkmenistan: "TKM",
  Tuvalu: "TUV",
  Ukraine: "UKR",
  "United Arab Emirates": "ARE",
  "United Kingdom": "GBR",
  Uruguay: "URY",
  Uzbekistan: "UZB",
  Vanuatu: "VUT",
  "Vatican City": "VAT",
  Yemen: "YEM",
  Zambia: "ZMB",
  Zimbabwe: "ZWE",
};

export const countryCoordinates = {
  "United States": [-95.7129, 37.0902],
  Brazil: [-51.9253, -14.235],
  Vietnam: [108.2772, 14.0583],
  Colombia: [-74.2973, 4.5709],
  Indonesia: [113.9213, -0.7893],
  Ethiopia: [39.7823, 9.145],
  Honduras: [-86.2419, 15.2],
  India: [78.9629, 20.5937],
  Bangladesh: [90.3563, 23.685],
  Uganda: [32.2903, 1.3733],
  Mexico: [-102.5528, 23.6345],
  Guatemala: [-90.2308, 15.7835],
  Peru: [-75.0152, -9.1899],
  Nicaragua: [-85.2072, 12.8654],
  China: [104.1954, 35.8617],
  "Ivory Coast": [-5.5471, 7.539988],
  "Costa Rica": [-83.7534, 9.7489],
  Kenya: [37.9062, -0.0236],
  "Papua New Guinea": [143.9555, -6.314993],
  Tanzania: [34.8888, -6.369],
  "El Salvador": [-88.8965, 13.7942],
  Ecuador: [-78.1834, -1.8312],
  Cameroon: [12.3547, 7.3697],
  Laos: [102.4955, 19.8563],
  Venezuela: [-66.5897, 6.4238],
  "Dominican Republic": [-70.1627, 18.7357],
  Haiti: [-72.2852, 18.9712],
  "Democratic Republic of the Congo": [21.7587, -4.0383],
  Rwanda: [29.8739, -1.9403],
  Burundi: [29.9189, -3.3731],
  Philippines: [121.774, 12.8797],
  // Additional countries
  Afghanistan: [67.709, 33.9391],
  Albania: [20.1683, 41.1533],
  Algeria: [1.6596, 28.0339],
  Andorra: [1.5218, 42.5063],
  Angola: [17.8739, -11.2027],
  "Antigua and Barbuda": [-61.7964, 17.0608],
  Argentina: [-63.6167, -38.4161],
  Armenia: [45.0382, 40.0691],
  Australia: [133.7751, -25.2744],
  Austria: [14.5501, 47.5162],
  Azerbaijan: [47.5769, 40.1431],
  Bahamas: [-77.39628, 25.03428],
  Bahrain: [50.6371, 26.0667],
  Barbados: [-59.5432, 13.1939],
  Belarus: [27.9534, 53.7098],
  Belgium: [4.4699, 50.5039],
  Belize: [-88.49765, 17.189877],
  Benin: [2.3158, 9.3077],
  Bhutan: [90.4336, 27.5142],
  Bolivia: [-63.5887, -16.2902],
  "Bosnia and Herzegovina": [17.6791, 43.9159],
  Botswana: [24.6849, -22.3285],
  Brunei: [114.7277, 4.5353],
  Bulgaria: [25.4858, 42.7339],
  "Burkina Faso": [-2.1833, 12.2383],
  "Cabo Verde": [-24.0132, 16.5388],
  Cambodia: [104.991, 12.5657],
  Canada: [-106.3468, 56.1304],
  "Central African Republic": [20.9394, 6.6111],
  Chad: [18.7322, 15.4542],
  Chile: [-71.543, -35.6751],
  Comoros: [43.8711, -11.6455],
  Congo: [15.8277, -0.228],
  "Cook Islands": [-159.7777, -21.2367],
  Croatia: [15.2, 45.1],
  Cuba: [-77.7812, 21.5218],
  Cyprus: [33.4299, 35.1264],
  "Czech Republic": [15.4729, 49.8175],
  Denmark: [9.5018, 56.2639],
  Djibouti: [42.5903, 11.8251],
  Dominica: [-61.371, 15.414],
  "East Timor": [125.7275, -8.8742],
  Egypt: [30.8025, 26.8206],
  "Equatorial Guinea": [10.2679, 1.6508],
  Eritrea: [39.7823, 15.7394],
  Estonia: [25.0136, 58.5953],
  Eswatini: [31.4659, -26.5225],
  Fiji: [179.4144, -16.5781],
  Finland: [25.7482, 61.9241],
  France: [2.2137, 46.2276],
  Gabon: [11.6094, -0.8037],
  Gambia: [-15.3101, 13.4432],
  Georgia: [43.3569, 42.3154],
  Germany: [10.4515, 51.1657],
  Ghana: [-1.0232, 7.9465],
  Greece: [21.8243, 39.0742],
  Grenada: [-61.679, 12.1165],
  Guinea: [-9.6966, 9.9456],
  "Guinea-Bissau": [-15.1804, 11.8037],
  Guyana: [-58.9302, 4.8604],
  Hungary: [19.5033, 47.1625],
  Iceland: [-19.0208, 64.9631],
  Iran: [53.688, 32.4279],
  Iraq: [43.6793, 33.2232],
  Ireland: [-8.2439, 53.4129],
  Israel: [34.8516, 32.0853],
  Italy: [12.5674, 41.8719],
  Jamaica: [-77.2975, 18.1096],
  Japan: [138.2529, 36.2048],
  Jordan: [36.2384, 30.5852],
  Kazakhstan: [66.9237, 48.0196],
  Kiribati: [-157.363, 1.8709],
  Kuwait: [47.4818, 29.3117],
  Kyrgyzstan: [74.7661, 41.2044],
  Latvia: [24.6032, 56.8796],
  Lebanon: [35.8623, 33.8547],
  Lesotho: [28.2336, -29.61],
  Liberia: [-9.4295, 6.4281],
  Libya: [17.2283, 26.3351],
  Liechtenstein: [9.5554, 47.166],
  Lithuania: [23.8813, 55.1694],
  Luxembourg: [6.1296, 49.8153],
  Madagascar: [46.8691, -18.7669],
  Malawi: [34.3015, -13.2543],
  Malaysia: [101.9758, 4.2105],
  Maldives: [73.2207, 3.2028],
  Mali: [-3.9962, 17.5707],
  Malta: [14.3754, 35.9375],
  "Marshall Islands": [171.1845, 7.1315],
  Mauritania: [-10.9408, 21.0079],
  Mauritius: [57.5522, -20.3484],
  Micronesia: [150.5508, 7.4256],
  Moldova: [28.3699, 47.4116],
  Monaco: [7.4246, 43.7384],
  Mongolia: [103.8467, 46.8625],
  Montenegro: [19.3744, 42.7087],
  Morocco: [-7.0926, 31.7917],
  Mozambique: [35.5296, -18.6657],
  Myanmar: [95.956, 21.9162],
  Namibia: [18.4904, -22.9576],
  Nauru: [166.9315, -0.5228],
  Nepal: [84.124, 28.3949],
  Netherlands: [5.2913, 52.1326],
  "New Zealand": [174.886, -40.9006],
  Niger: [8.0817, 17.6078],
  Nigeria: [8.6753, 9.082],
  "North Korea": [127.5101, 40.3399],
  "North Macedonia": [21.7453, 41.6086],
  Norway: [8.4689, 60.472],
  Oman: [55.9754, 21.4735],
  Pakistan: [69.3451, 30.3753],
  Palau: [134.5825, 7.515],
  Palestine: [35.2332, 31.9522],
  Panama: [-80.7821, 8.538],
  Paraguay: [-58.4438, -23.4425],
  Poland: [19.1343, 51.9194],
  Portugal: [-8.2245, 39.3999],
  Qatar: [51.1839, 25.3548],
  Romania: [24.9668, 45.9432],
  Russia: [105.3188, 61.524],
  "Saint Kitts and Nevis": [-62.783, 17.3578],
  "Saint Lucia": [-60.9789, 13.9094],
  "Saint Vincent and the Grenadines": [-61.2872, 12.9843],
  Samoa: [-172.1046, -13.759],
  "San Marino": [12.4578, 43.9424],
  "Sao Tome and Principe": [6.6071, 0.1864],
  "Saudi Arabia": [45.0792, 23.8859],
  Senegal: [-14.4524, 14.4974],
  Serbia: [21.0059, 44.0165],
  Seychelles: [55.492, -4.6796],
  "Sierra Leone": [-11.7799, 8.4606],
  Singapore: [103.8198, 1.3521],
  Slovakia: [19.699, 48.669],
  Slovenia: [14.9955, 46.1512],
  "Solomon Islands": [160.1562, -9.6457],
  Somalia: [46.1996, 5.1521],
  "South Africa": [22.9375, -30.5595],
  "South Korea": [127.7669, 35.9078],
  "South Sudan": [31.3069, 6.877],
  Spain: [-3.7492, 40.4637],
  "Sri Lanka": [80.7718, 7.8731],
  Sudan: [30.2176, 12.8628],
  Suriname: [-56.0278, 3.9193],
  Sweden: [18.6435, 60.1282],
  Switzerland: [8.2275, 46.8182],
  Syria: [38.9968, 34.8021],
  Tajikistan: [71.2761, 38.861],
  Thailand: [100.9925, 15.87],
  Togo: [0.8248, 8.6195],
  Tonga: [-175.1982, -21.1789],
  "Trinidad and Tobago": [-61.2225, 10.6918],
  Tunisia: [9.5375, 33.8869],
  Turkey: [35.2433, 38.9637],
  Turkmenistan: [59.5563, 38.9697],
  Tuvalu: [177.6493, -7.1095],
  Ukraine: [31.1656, 48.3794],
  "United Arab Emirates": [53.8478, 23.4241],
  "United Kingdom": [-3.436, 55.3781],
  Uruguay: [-55.7658, -32.5228],
  Uzbekistan: [64.5853, 41.3775],
  Vanuatu: [166.9592, -15.3767],
  "Vatican City": [12.4534, 41.9029],
  Yemen: [48.5164, 15.5527],
  Zambia: [27.8546, -13.1339],
  Zimbabwe: [29.1549, -19.0154],
};
